// Card compartida "próximo inicio" / "no opera" (design horario-turno-dia
// §6): usada por L2CapturaPage, CapturaTiendaPage y SelectorLineaPage cuando
// el Líder no tiene ninguna programación operativa hoy para la línea/turno
// que abrió. Orden evaluado (excluyente, ya resuelto por el backend en
// GET /api/contexto-lider, design §5): `proximoInicio` primero, `diaSinTurno`
// solo si ese es nulo.
//
// Sin cuenta regresiva (alcance recortado de esta entrega): el texto es
// estático, recalculado solo al refrescar `contexto-lider`.
import type { ContextoLider } from 'schemas';
import { textoProximoInicio } from '../../lib/textoProximoInicio';

interface EstadoTurnoCardProps {
  proximoInicio: ContextoLider['proximo_inicio'];
  diaSinTurno: ContextoLider['dia_sin_turno'];
  /** fake-UTC "YYYY-MM-DDTHH:MM" — combinar `fecha_hoy` + `hora_servidor` del contexto. */
  ahoraLocal: string;
}

/** null si ninguno de los dos aplica — el llamador cae a su estado vacío actual. */
export function EstadoTurnoCard({ proximoInicio, diaSinTurno, ahoraLocal }: EstadoTurnoCardProps) {
  if (proximoInicio) {
    return (
      <div className="flex flex-col items-center gap-1 text-center">
        <p className="text-lg font-medium text-fg">
          {textoProximoInicio(proximoInicio.inicio_local, ahoraLocal)}
        </p>
      </div>
    );
  }

  if (diaSinTurno) {
    return (
      <div className="flex flex-col items-center gap-1 text-center">
        <h1 className="text-lg font-medium text-fg">Su turno no opera hoy</h1>
        <p className="text-sm text-fg-secondary">
          Si cree que es un error, consulte con su coordinador.
        </p>
      </div>
    );
  }

  return null;
}
